/**
 * Global sound effects manager
 * Allows playSoundEffect to access context values without requiring hooks
 */

import { isExploreUnknownKendrexColonyAudioSuppressed } from '../utils/exploreUnknownKendrexColonyAudio';

let soundsEnabled = true;
let soundsVolume = 0.5;
let masterVolume = 1;

export function setSoundSettings(enabled, volume, master = undefined) {
  soundsEnabled = enabled;
  soundsVolume = volume;
  if (typeof master === 'number' && Number.isFinite(master)) {
    masterVolume = Math.min(1, Math.max(0, master));
  }
}

export function getSoundSettings() {
  return { soundsEnabled, soundsVolume, masterVolume };
}

/**
 * Master SFX/voice output: user slider × per-clip gain, clamped to [0, 1].
 * Callers should not play audio when this returns null (sounds disabled).
 *
 * @param {number} [relativeClipGain=1] - Per-effect multiplier (e.g. 0.5 for quieter deploy SFX vs full voice line).
 * @returns {null | number}
 */
export function getEffectiveSoundOutputVolume(relativeClipGain = 1, soundPath = null) {
  if (!soundsEnabled) return null;
  if (isExploreUnknownKendrexColonyAudioSuppressed(soundPath)) return null;
  const g =
    typeof relativeClipGain === 'number' && Number.isFinite(relativeClipGain)
      ? Math.max(0, relativeClipGain)
      : 1;
  return Math.min(1, masterVolume * soundsVolume * g);
}
